<template>
  <HeroTotalPackage />
  <MainHeader :isMinimal="true" :scrolled="scrolled" />
  <AgitationTimelineSection />
  <SolutionBridgeSection />
  <BenefitsSection />
  <JourneyTimeline />
  <SocialProofSection />
  <RiskReversalSection />
  <SmartLeadCtaSection />
  <DeepDiveSection />
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import HeroTotalPackage from "@/components/sections/cta/HeroTotalPackage.vue";
import AgitationTimelineSection from "@/components/sections/features/AgitationTimelineSection.vue";
import SolutionBridgeSection from "@/components/sections/features/SolutionBridgeSection.vue";
import BenefitsSection from "@/components/sections/features/BenefitsSection.vue";
import SocialProofSection from "@/components/sections/features/SocialProofSection.vue";
import JourneyTimeline from "@/components/sections/features/JourneyTimeline.vue";
import RiskReversalSection from "@/components/sections/features/RiskReversalSection.vue";
import SmartLeadCtaSection from "@/components/sections/cta/SmartLeadCtaSection.vue";
import DeepDiveSection from "@/components/sections/deep-dive/DeepDiveSection.vue";
import MainHeader from "@/components/headers/MainHeader.vue";
const showExitOverlay = ref(false);
onMounted(() => {
  document.addEventListener("mouseout", e => {
    if (e.clientY < 10) showExitOverlay.value = true;
  });
});

const scrolled = ref(false);

onMounted(() => {
  const heroEl = document.getElementById("hero");
  if (!heroEl) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      scrolled.value = !entry.isIntersecting;
    },
    {
      root: null, // viewport
      threshold: 0,
      rootMargin: "0px 0px -1px 0px", // triggers just as hero exits
    }
  );

  observer.observe(heroEl);

  onUnmounted(() => {
    observer.disconnect();
  });
});
</script>
